import React from "react"

import * as ctaSectionEduStyles from "../styles/CtaSectionEdu.module.css"

import { ChildSelector } from "../helpers/ChildSelector"

import WPCta from "./_base/WPCta"
import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

export default function GenericSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `cta-edu-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  return (
    <>
      <div className={`row justify-content-center ${props.className} ${ctaSectionEduStyles.wrapper}`}>
        <div className={`col-12 ${ctaSectionEduStyles.ctaWrapper}`}>
          <WPCta
            holder={content}
            selector={`cta-edu-btn`}
            translate={true}
            className={`${ctaSectionEduStyles.ctaBtn}`}
            pageContext={props.pageContext}
          />
          <div className={`row ${ctaSectionEduStyles.contentWrapper}`}>
            <div className={`col-xs-12 col-sm-12 col-md-7 col-lg-7 ${ctaSectionEduStyles.content}`}>
              <h3
                dangerouslySetInnerHTML={{
                  __html: title,
                }}
              />
            </div>
            {ChildSelector.select(content, 'edu-icon', ChildSelector.SELECTOR_TYPE.NODE) && (
              <div className={`col-xs-12 col-sm-12 col-md-5 col-lg-5 ${ctaSectionEduStyles.media}`}>
                <WPImage
                  holder={content}
                  selector={`edu-icon`}
                  mode={DISPLAY_MODE.normal}
                />
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  )
}
